import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || Digitoze </title>
                    <meta name="description" content={this.props.pageDescription} />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
